let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9bjiA")).then(() => parcelRequire('fpkYN'));